// store/index.ts
import { createStore } from 'vuex';

export default createStore({
  state: {
    isLoggedIn: false,
  },
  mutations: {
    SET_LOGGED_IN(state, status) {
      state.isLoggedIn = status;
      if (status == true){
        localStorage.setItem('isLoggedIn', '1'); // 保存到 localStorage
      }

    },
  },
  actions: {
    setLoggedIn({ commit }, status) {
      commit('SET_LOGGED_IN', status);
    },
    logout({ commit }) {
      commit('SET_LOGGED_IN', false);
      localStorage.setItem('isLoggedIn','0');
      localStorage.removeItem('accessToken'); // 清除 token
      // 可以在这里添加其他清理操作
      localStorage.removeItem('username');
      localStorage.removeItem('password');
      localStorage.removeItem('userId');
      localStorage.removeItem('nickName');
      localStorage.removeItem('organizationName');
      localStorage.removeItem('role');
    }
  }
});
